import { Dialog as MuiDialog, IconButton } from "@mui/material";
import styled from "@emotion/styled";

export const CloseButton = styled(IconButton)({
  "&": {
    position: "absolute",
    right: 8,
    top: 8,
  },
});

export const Dialog = styled(MuiDialog)({
  "& .MuiDialogContent-root": {
    paddingBottom: 0,
  },

  "& .MuiDialogActions-root": {
    padding: 16,
  },
});
